import dynamic from "next/dynamic";
// TODO: Please import ALL Modules dynamically see above components for example not this does not apply for Type Definitions
const Text = dynamic(() => import("../components/Text/Text"));
const TextMedia = dynamic(() => import("../components/TextMedia/TextMedia"));
const Media = dynamic(() => import("../components/Media/MediaModul"));
const Accordion = dynamic(() => import("../components/Accordion/Accordion"));

const InfoBoxesModule = dynamic(
  () => import("../components/InfoBoxModule/InfoBoxesModule"),
);
// const EventsSlider = dynamic(
//   () => import("../components/EventsSlider/EventsSlider"),
// );

const Insta = dynamic(() => import("../components/Socials/Insta/Insta"));
const Timeline = dynamic(() => import("../components/Timeline/Timeline"));
const FactsGrid = dynamic(() => import("../components/Facts/Facts"));
const TeaserSliderModule = dynamic(
  () => import("../modules/TeaserSlider/TeaserSlider"),
);
const FullWidthSlider = dynamic(
  () => import("../components/FullWidthSlider/FullWidthSlider"),
);
const ImageGridModule = dynamic(() => import("../modules/ImageGrid/ImageGrid"));
const NewsLetter = dynamic(() => import("../components/NewsLetter/NewsLetter"));
const QuoteGridModule = dynamic(
  () => import("../modules/QuotesGrid/QuotesGrid"),
);
const ZitateSlider = dynamic(
  () => import("../modules/QuoteSliderModule/QuoteSliderModule"),
);
const LogoSliderModule = dynamic(
  () => import("../modules/LogoSliderModule/LogoSliderModule"),
);
const EventGridModule = dynamic(() => import("../modules/EventGrid/EventGrid"));
const PostsGridModule = dynamic(() => import("../modules/PostGrid/PostGrid"));
const ImageSliderModule = dynamic(
  () => import("../modules/ImageSlider/ImageSlider"),
);
const PostSliderModule = dynamic(
  () => import("../modules/PostSlider/PostSlider"),
);
const EventSliderModule = dynamic(
  () => import("../modules/EventSlider/EventSlider"),
);
const LogosGridModule = dynamic(() => import("../modules/LogosGrid/LogosGrid"));

const TextMediaBig = dynamic(
  () => import("../components/TextMediaBig/TextMediaBig"),
);

const MediaBackground = dynamic(
  () => import("../components/MediaBackground/MediaBackground"),
);

const MagazinGrid = dynamic(() => import("../modules/MagazinGrid/MagazinGrid"));
const GlossarGrid = dynamic(() => import("../modules/GlossarGrid/GlossarGrid"));
const TeamGrid = dynamic(() => import("../modules/TeamGrid/TeamGrid"));
const QuotesBanner = dynamic(
  () => import("../components/QuotesBanner/QuotesBanner"),
);

const ContactFormModule = dynamic(
  () => import("../modules/ContactForm/ContactForm"),
);

const Table = dynamic(() => import("../components/Table/Table"));

const RecipeTeaserModule = dynamic(
  () => import("../modules/RecipeTeaser/RecipeTeaser"),
);

const RecipeSliderModule = dynamic(
  () => import("../modules/RecipeSlider/RecipeSlider"),
);

const RecipeGridMoudle = dynamic(
  () => import("../modules/RecipeGrid/RecipeGrid"),
);

const CtaBannerModule = dynamic(() => import("../modules/CtaBanner/CtaBanner"));

import {
  HeadersOptionsType,
  ModuleOptionsType,
} from "@/types/ModuleOptionsType";
import { BreakpointsOptionsType } from "./getData/getBreakpoints";

import {
  NewsLetterOptionType,
  OptionsBackgroundLayoutType,
  OptionsContactFormType,
  OptionsEndCardsType,
  OptionsHeaderType,
  OptionsSocialMediaType,
  OptionsTopfiGraphicsType,
} from "@/types/OptionType";
import { FullWidthSliderDataType } from "./getData/getFullWidthSliderData";
import { IndexedEventSliderData } from "../modules/EventSlider/getIndexedEventSliderData";
import { getSingleModuleData } from "./getModulData";
import { IndexedPostSlidereData } from "../modules/PostSlider/getIndexedPostSliderData";

import { Module } from "../wp/types/acf-module-types";
import { TeaserSliderElementType } from "../components/TeaserCard/TeaserCard";
import { QuotesElementType } from "@/types/QuoteType";
import { Header_Logos } from "@/wp/types/acf-header-types";
import { SingleImageSlider } from "@/modules/SingleImageSlider/SingleImageSlider";
import { CampaignBanner } from "@/components/CampaignBanner/CampaignBanner.tsx";
import { ParentsType } from "@/wp/getParentPages";
import { Post } from "@/wp/types/client";
import { IndexedRecipeSlidereData } from "@/modules/RecipeSlider/getIndexedRecipeSliderData";
import { GlossarReturnedType } from "@/types/baseTypes";
import { SortedCategoriesType } from "./rezeptAPI/getRecipeFilterOptions";
import { RecipeGridResponseType } from "@/modules/RecipeGrid/fetchRecipes";

// TODO never pass full options object to module only pass the options that are actually used with moduleOptions
interface ModulesProps {
  index: number;
  module: Module["module"][number];
  moduleOptions: ModuleOptionsType;
  breakpoints: BreakpointsOptionsType | null;
  insta: string;
  parents: ParentsType;
  post: Post;
  socialMedia: OptionsSocialMediaType;
  teaserSliderData: TeaserSliderElementType[];
  fullWidthSliderData?: FullWidthSliderDataType;
  newsletterOptions: NewsLetterOptionType;
  quotesSliderData: QuotesElementType[];
  logoElements: Header_Logos["header_logos"][];
  indexedEventSliderData: IndexedEventSliderData;
  indexedPostSliderData: IndexedPostSlidereData;
  indexedRecipeSliderData: IndexedRecipeSlidereData;
  isBigParagraph?: boolean;
  contactOptions: OptionsContactFormType;
  fallbackImages: OptionsHeaderType["fallback_images"];
  endCards: OptionsEndCardsType;
  headerOptions: HeadersOptionsType;
  backgroundImages: OptionsBackgroundLayoutType;
  initialRecipeData: RecipeGridResponseType | null;
  recipeFilterOptions: SortedCategoriesType;
  topfiGraphics: OptionsTopfiGraphicsType;
  glossarData?: GlossarReturnedType;
}

export const Modules = (props: ModulesProps) => {
  switch (props.module.acf_fc_layout) {
    case "text":
      return (
        <Text
          data={props.module}
          textOptions={props.moduleOptions.text!}
          isBigParagraph={props.isBigParagraph}
          backgroundImages={props.backgroundImages}
          topfiGraphics={props.topfiGraphics}
        />
      );
    case "media":
      return (
        <Media
          data={props.module}
          mediaOptions={props.moduleOptions.media!}
          backgroundImages={props.backgroundImages}
        />
      );
    case "textmedia":
      return (
        <TextMedia
          data={props.module}
          textmediaOptions={props.moduleOptions.textmedia!}
          breakpoints={props.breakpoints}
          isBigParagraph={props.isBigParagraph}
          backgroundImages={props.backgroundImages}
        />
      );
    case "textmedia_big":
      return (
        <TextMediaBig
          data={props.module}
          textmediaBigOptions={props.moduleOptions.textmedia_big!}
          breakpoints={props.breakpoints}
        />
      );
    case "grid":
      return (
        <PostsGridModule
          data={props.module}
          postsGridOptions={props.moduleOptions.grid!}
          fallback_image={props.fallbackImages.header_posts}
        />
      );
    case "slider":
      //get data only if module is actually used at the current index to throw an error if module data is undefined and we can ensure that is exist from here on
      const postSliderData = getSingleModuleData(
        props.indexedPostSliderData,
        props.index,
      );
      return (
        <PostSliderModule
          data={props.module}
          postsSliderOptions={props.moduleOptions.slider!}
          postSliderData={postSliderData}
          endCardData={props.endCards?.slider}
        />
      );
    case "accordion":
      return (
        <Accordion
          data={props.module}
          accordionOptions={props.moduleOptions.accordion!}
          index={props.index}
        />
      );
    case "image_slider":
      return (
        <ImageSliderModule
          data={props.module}
          imageSliderOptions={props.moduleOptions.image_slider!}
        />
      );
    case "infoboxes":
      return (
        <InfoBoxesModule
          data={props.module}
          infoBoxOptions={props.moduleOptions.infoboxes!}
        />
      );
    case "timeline":
      return (
        <Timeline
          data={props.module}
          timelineOptions={props.moduleOptions.timeline!}
        />
      );
    case "events_slider":
      //get data only if module is actually used at the current index to throw an error if module data is undefined and we can ensure that is exist from here on
      const eventSliderData = getSingleModuleData(
        props.indexedEventSliderData,
        props.index,
      );
      return (
        <EventSliderModule
          data={props.module}
          eventsSliderOptions={props.moduleOptions.events_slider!}
          eventSliderData={eventSliderData}
          endCardData={props.endCards?.events_slider}
        />
      );
    case "events_grid":
      return (
        <EventGridModule
          data={props.module}
          eventsGridOptions={props.moduleOptions.events_grid!}
        />
      );

    case "instagram":
      return (
        <Insta
          data={props.module}
          options={props.moduleOptions.instagram!}
          feed={props.insta}
          socialMedia={props.socialMedia}
        />
      );
    case "facts_grid":
      return (
        <FactsGrid
          data={props.module}
          factsGridOptions={props.moduleOptions.facts_grid!}
        />
      );
    case "teaser_slider":
      return (
        <TeaserSliderModule
          data={props.module}
          teaserSliderOptions={props.moduleOptions.teaser_slider!}
          teaserSliderData={props.teaserSliderData}
        />
      );
    case "fullwidth_slider":
      return (
        <FullWidthSlider
          data={props.module}
          fullWidthSliderData={props.fullWidthSliderData}
          fullWidthSliderOptions={props.moduleOptions.fullwidth_slider}
          breakpoints={props.breakpoints}
        />
      );
    case "image_grid":
      return (
        <ImageGridModule
          data={props.module}
          imageGridOptions={props.moduleOptions.image_grid!}
        />
      );
    case "newsletter":
      return (
        <NewsLetter
          data={props.module}
          newsletterOptions={props.newsletterOptions}
          nesletterTemplateOptions={props.moduleOptions.newsletter_options!}
        />
      );
    case "quotes_grid":
      return (
        <QuoteGridModule
          data={props.module}
          zitateGridOptions={props.moduleOptions.quotes_grid!}
          moduleIndex={props.index}
        />
      );
    case "quotes_slider":
      return (
        <ZitateSlider
          data={props.module}
          quotesSliderOptions={props.moduleOptions.quotes_slider!}
          quotesSliderData={props.quotesSliderData}
          index={props.index}
          endCardData={props.endCards.quotes_slider}
        />
      );

    case "logos_slider":
      return (
        <LogoSliderModule
          data={props.module}
          logoSliderOptions={props.moduleOptions.logos_slider!}
          logoElements={props.logoElements}
        />
      );
    case "logos_grid":
      return (
        <LogosGridModule
          data={props.module}
          logosGridOptions={props.moduleOptions.logos_grid!}
        />
      );
    case "magazine_grid":
      return (
        <MagazinGrid
          fallbackImage={
            props.headerOptions.header_magazine?.show_fallback_image
              ? props.fallbackImages.header_magazine
              : undefined
          }
          data={props.module}
          magazinGridOptionsType={props.moduleOptions.magazine_grid!}
        />
      );
    case "glossary_grid":
      return (
        <GlossarGrid
          data={props.module}
          breadcrumb={{ post: props.post, parents: props.parents }}
          glossarGridOptions={props.moduleOptions.glossary_grid!}
          // glossarHeaderOptions={props.headerOptions.header_glossar!}
          glossarData={props.glossarData}
        />
      );
    case "mediabackground":
      return (
        <MediaBackground
          data={props.module}
          mediaBackgroundOptions={props.moduleOptions.mediabackground!}
          breakpoints={props.breakpoints}
        />
      );

    case "team_grid":
      return (
        <TeamGrid
          data={props.module}
          gridOptions={props.moduleOptions.team_grid!}
          socialMedia={props.socialMedia}
          teamheaderOptions={props.headerOptions.header_team}
        />
      );
    case "contact_form":
      return (
        <ContactFormModule
          data={props.module}
          options={props.contactOptions}
          contactFormOptions={props.moduleOptions.contact_form!}
        />
      );
    case "quotes_banner":
      return (
        <QuotesBanner
          data={props.module}
          QuotesBannerOptions={props.moduleOptions.quotes_banner!}
        />
      );
    case "single_image_slider":
      return (
        <SingleImageSlider
          data={props.module}
          options={props.moduleOptions.single_image_slider!}
        />
      );
    case "tables":
      return (
        <Table data={props.module} options={props.moduleOptions.tables!} />
      );
    case "recipe_teaser":
      return (
        <RecipeTeaserModule
          backgroundImages={props.backgroundImages}
          {...props.module}
        />
      );
    case "recipe_slider":
      const recipeSliderData = getSingleModuleData(
        props.indexedRecipeSliderData,
        props.index,
      );

      return (
        <RecipeSliderModule
          data={props.module}
          recipeSliderData={recipeSliderData}
          backgroundImages={props.backgroundImages}
        />
      );
    case "recipe_grid":
      return (
        <RecipeGridMoudle
          data={props.module}
          initialData={props.initialRecipeData}
          filterOptions={props.recipeFilterOptions}
          fallback_image={props.fallbackImages.header_posts}
        />
      );
    case "cta":
      return (
        <CtaBannerModule
          data={props.module}
          topfiGraphics={props.topfiGraphics}
          backgroundImages={props.backgroundImages}
        />
      );
    case "campaign_box":
      return <CampaignBanner data={props.module} user={null} />;
    default:
      return null;
  }
};
